import React, { Component } from 'react';
import Messenger from '../../views/components/messenger.js';

/**
 * Generic component to build output textboxes
 */
export default class OutputTextbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: props.search || '',
      output: props.output || [],
    };
    this.eventUpdate = this.eventUpdate.bind(this);
    this.textArea = React.createRef();
  }

  formatLog(log) {
    return log;
  }

  loadData() {
    let stateValue;

    fetch(this.props.logUrl)
      .then((response) => response.json())
      .then((data) => {
        try {
          stateValue = data;
        } catch {
          stateValue = [];
        } finally {
          this.setState({ output: stateValue });
        }
      });
  }

  componentDidMount() {
    if (this.props.logUrl) {
      this.loadData();
    }
    if (this.props.updateChannel) {
      Messenger.on(this.props.updateChannel, this.eventUpdate);
    }
    // Without the timer, the scrollHeight is always zero (see: github.com/facebook/react/issues/13108)
    setTimeout(() => {
      this.scrollToBottom();
    }, 1);
  }

  componentWillUnmount() {
    if (this.props.updateChannel) {
      Messenger.off(this.props.updateChannel, this.eventUpdate);
    }
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  eventUpdate(data) {
    this.setState({ output: data });
  }

  scrollToBottom() {
    this.textArea.current.scrollTop = this.textArea.current.scrollHeight;
  }

  getOutput() {
    let output = this.formatLog(this.state.output);

    if (this.state.search === '') {
      return output.join(`\n`);
    }
    return output
      .filter(
        (i) => i.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1,
      )
      .join(`\n`);
  }

  handleChange(e) {
    this.setState({ search: e.target.value });
  }

  render() {
    return (
      <div className='outputContainer ui form'>
        <div className='field'>
          <input
            className='outputSearch'
            placeholder='Type to filter the output'
            type='text'
            value={this.state.search}
            onChange={this.handleChange.bind(this)}
          />
        </div>
        <textarea
          ref={this.textArea}
          readOnly
          rows='20'
          value={this.getOutput()}
        />
      </div>
    );
  }
}
